import React from "react";

import Alerter from "../../../Components/Common/Alerter";
import ContactModal from "../../../Components/Common/ContactModal";

const ContactMeContainer = ({contactDetails, productTypeTitle, productDetailTitle}) => {
    const contactDetailsList = JSON.parse(contactDetails);
    const [showModal, setShowModal] = React.useState(false);

    const handleModalToggle = () => {
        setShowModal(!showModal);
    };

    return (
        <>
            <button className="btn btn-primary text-center px-4 py-2 w-100" onClick={handleModalToggle}>
                <div className="font-weight-bold text-white">
                    Bel mij terug
                </div>
            </button>
            {showModal && (
                <Alerter onCancel={handleModalToggle}>
                    {(onCancel) => (
                        <ContactModal
                            contactDetails={contactDetailsList}
                            onSend={handleModalToggle}
                            onCancel={onCancel}
                            data={{
                                partno: "",
                                productKey: "",
                                product_title: "",
                                product_type_title: productTypeTitle,
                                product_group_title: "",
                                product_detail_title: productDetailTitle,
                            }}
                        />
                    )}
                </Alerter>
            )}
        </>
    )
}

export default ContactMeContainer;